import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';
import { StyledSelect } from './RegionSettlementsListStyles';
import { IRegionSettlement } from '@/models/regions.model';
import { getRegionActiveOptions, getSettlementHeaderOptions } from '../../helpers/getOptions';

type TGetPartnersTableColumns = {
  t: TFunction;
  onStatusChange: (id: string) => void;
  onInHeaderToggle: (id: string) => void;
  canManage: boolean;
};

export const getRegionSettlementsTableColumns = ({
  t,
  onStatusChange,
  onInHeaderToggle,
  canManage,
}: TGetPartnersTableColumns): ColumnsType<IRegionSettlement> => {
  return [
    {
      title: t('region_settlements_settlement_ua'),
      dataIndex: 'name_ua',
      key: 'name_ua',
      render: (_, record) => <span>{record.locale?.uk?.name}</span>,
    },
    {
      title: t('region_settlements_settlement_ru'),
      dataIndex: 'name_ru',
      key: 'name_ru',
      render: (_, record) => <span>{record.locale?.ru?.name}</span>,
    },
    {
      title: t('regions_table_status'),
      dataIndex: 'active',
      key: 'active',
      render: (active, record) => {
        const handleStatusChange = () => onStatusChange(record.id);
        return (
          <span>
            <StyledSelect
              $isActive={!!active}
              options={getRegionActiveOptions(t)}
              value={active}
              onChange={handleStatusChange}
              disabled={!canManage}
            />
          </span>
        );
      },
    },
    {
      title: t('regions_table_header_label'),
      dataIndex: 'in_header',
      key: 'in_header',
      render: (in_header, record) => {
        const handleStatusChange = () => onInHeaderToggle(record.id);
        return (
          <span>
            <StyledSelect
              $isActive={!!in_header}
              options={getSettlementHeaderOptions(t)}
              value={in_header}
              onChange={handleStatusChange}
              disabled={!canManage}
            />
          </span>
        );
      },
    },
  ];
};
